import { render, staticRenderFns } from "./allMerchant.vue?vue&type=template&id=c2e2df7a&scoped=true&"
import script from "./allMerchant.vue?vue&type=script&lang=js&"
export * from "./allMerchant.vue?vue&type=script&lang=js&"
import style0 from "./allMerchant.vue?vue&type=style&index=0&id=c2e2df7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e2df7a",
  null
  
)

export default component.exports